<template>
  <div>
    <v-row class="dict_input ma-1">
    <v-col>
      <div>
        <div v-for="[key,val] in Object.entries({...value})">
          <Input
            :name="key"
            :readonly="readonly"
            :value="val"
            :roles="roles"
            @update="(new_val,new_key) => {update(key,new_val,new_key)}"
            @delete="delete_prop(key)"
          />
        </div>
      </div>
      <AddValue
        v-if="!readonly"
        dict_value
        @submit="update_add"
      />
    </v-col>
  </v-row>
</div>
  
</template>

<style lang="scss">
  .dict_input{
    border: 1px solid black;
    margin: 1px;
  }
</style>
  
<script>
  import StringInput from '@/components/bpcreator/inputs/StringInput';
  export default {
    components: {
      StringInput,
      Input: () => import('@/components/bpcreator/inputs/Input'),
      AddValue: () => import('@/components/bpcreator/model/AddValue'),
    },
      
    name: 'DictInput',
      
    props: {
      value: {default: () => ({})},
      readonly: Boolean,
      roles: {default: ()=>({})},
    },
      
    data: () => ({
      deafult_input: {
        id: '',
        label: '',
        required: false,
        value: '',
        readonly: false,
        cols: 4,
        class: null,
        component: 'TextInput',
        placeholder: "",
      },
      expanded: {},
    }),
      
    computed: {
    },
      
    mounted() {
    },
      
    methods: {
      update_add(values) {
        this.update(values.name,values.default_value);
      },

      update(id, value, new_key) {
        if (!!new_key) {
          //Name of the object has changed
          let entries = Object.entries(this.value);
          const index_id = entries.findIndex(it => it[0]==id);
          if (index_id >= 0) {
            entries[index_id] = Object.entries(value).flat();
          } else {
            entries.push(Object.entries(value).flat())
          }
            this.$emit('update',(Object.fromEntries(entries)));
        } else {
          // Normal value update
          this.$emit('update',({...this.value,[id]: value}));
        }
      },

      expand(id) {
        this.expanded[id] = !this.expanded[id];
        this.expanded = {...this.expanded}
      },

      delete_prop(key) {
        let new_obj = this.value;
        delete new_obj[key];
        this.$emit('update',new_obj);
        
      },
    },
  }
</script>